import React from 'react';
import PropTypes from 'prop-types';
import Page from 'Common/Layout/Page';
import moment from 'moment';
import CloseButton from '../../../../../Common/CloseButton/CloseButton';
import MarkerMeetingsDatatable from '../../Datatables/MarkerMeetingsDatatable';
import classes from '../contract-views.module.css';

const MarkerMeetings = ({ handleClose, title, contractTypes = [], year = Date.now().getFullYear(), keyField, columns = [] }) => {
	const fullTitle = `${title} (${contractTypes.join(', ')}) ${year}`;
	document.title = `Contract Management - ${fullTitle}`;

	return (
		<>
			<Page title={fullTitle}>
			</Page>
			<MarkerMeetingsDatatable keyField={keyField} columns={columns} contractTypes={contractTypes} />

			<span className={classes['action-buttons']}>
				<CloseButton closeOnClick={() => handleClose('')}>Close</CloseButton>
			</span>
		</>
	);
};

MarkerMeetings.propTypes = {
	show: PropTypes.bool.isRequired,
	handleClose: PropTypes.func.isRequired,
	title: PropTypes.string.isRequired,
	screenType: PropTypes.string.isRequired,
	contractTypes: PropTypes.array,
	year: PropTypes.number,
	keyField: PropTypes.string.isRequired,
	columns: PropTypes.array
};

MarkerMeetings.defaultProps = {
	contractTypes: ['MAR','CMK'],
	year: moment().year(),
	columns: []
};

export default MarkerMeetings;
